const reducer = key => (acum, emenda) => {
  return (acum += Number(emenda[key]))
}

export const getters = {
  quantidadeEmendas: ({ emendas }) => emendas.length,
  valorTotalEmendas: ({ emendas }) => {
    return emendas.reduce(reducer('valor'), 0)
  },
  quantidadeVereadores: ({ emendas }) => {
    const unique = [...new Set(emendas.map(item => item.vereador_id))]
    return unique.length
  },
  saldoTotal: ({ emendas }) => {
    return emendas.reduce(reducer('saldo'), 0)
  },
  valorTotalUtilizado: (_, getters) => {
    return getters.valorTotalEmendas - getters.saldoTotal
  },
  emendasPorSecretaria: ({ emendas }) => secretaria => {
    const filter = item => {
      return item.nome_orgao === secretaria
    }

    return emendas.filter(filter)
  },
  valorTotalPorSecretaria: (_, getters) => secretaria => {
    const emendasPorSecretaria = getters.emendasPorSecretaria(secretaria)

    return emendasPorSecretaria.reduce(reducer('valor'), 0)
  },
  saldoTotalPorSecretaria: (_, getters) => secretaria => {
    const emendasPorSecretaria = getters.emendasPorSecretaria(secretaria)

    return emendasPorSecretaria.reduce(reducer('saldo'), 0)
  },
  secretariasComEmendas: ({ emendas }) => {
    const secretarias = [
      ...new Set(
        emendas.map(emenda => {
          return emenda.nome_orgao
        })
      )
    ]

    return secretarias
  },
  vereadoresComEmendas: ({ emendas }) => {
    const vereadores = [
      ...new Set(
        emendas.map(emenda => {
          return emenda.vereador.nome
        })
      )
    ]

    return vereadores
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/emendas_parlamentares/getters.js